<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    @if (error) {
      <pr-color-panel [display]="'danger'">
        <pr-panel-body clazz="pam">
          <pr-label [name]="'error'" [width]="18" [height]="18">{{
            error?.message
          }}</pr-label>
        </pr-panel-body>
      </pr-color-panel>
    }
    <div class="row">
      <div class="col col-md-12">
        <pr-input-radio
          formControlName="investmentDuration"
          direction="column"
          [isDefault]="false"
          columns="1"
          [options]="projectDurationOptions"
          label="Durée de votre projet d’investissement"
        >
        </pr-input-radio>
      </div>
    </div>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
